{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "TrackingEvent",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "event",
    "params"
  ],
  "properties": {
    "event": {
      "title": "dataLayer event name",
      "type": "string",
      "pattern": "^[a-z][a-z0-9_]{2,40}$"
    },
    "params": {
      "title": "Parameters",
      "type": "array",
      "maxItems": 10,
      "x-ui": "list",
      "x-itemTitle": "key",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "value"
        ],
        "properties": {
          "key": {
            "title": "Key",
            "type": "string",
            "pattern": "^[a-z][a-z0-9_]{1,40}$"
          },
          "value": {
            "title": "Value",
            "type": "string",
            "maxLength": 100
          }
        }
      }
    }
  }
}
